import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { DialogContent, Grid, LinearProgress, Button } from '@material-ui/core'
import { useDispatch } from 'react-redux'
import { importMassivePaymentValidateTemplate } from '../../../store/paymentrequests/paymentRequestActions'
import PanelHeaderIcon from '../../common/lateralPanel/PanelHeaderIcon'
import LateralPanel from '../../common/lateralPanel/LateralPanel'
import AlertComponent from '../../common/AlertComponent'
import ButtonConfirm from '../../common/Buttons/ButtonConfirm'
import DropDownZone from '../../common/DropDownZone'
import FileContent from '../../common/FileContent'
import iconDownload from '../../../resources/images/importIcon.png'
import CloudDownloadIcon from '@material-ui/icons/CloudDownload'
import downloadTemplate from '../../../resources/files/MassivePaymentTemplate.xlsx'

const UploadMassiveImportPanel = (props) => {
	const dispatch = useDispatch()
	const { isSaving, onCloseButtonClick, onImportMassivePaymentRequest } = props
	const [files, setFiles] = useState([])
	const [paymentRequestValidateTemplate, setPaymentRequestValidateTemplate] = useState(null)

	const canBeSaved = () => files.length === 0
	const hasErrors = paymentRequestValidateTemplate?.TotalErrors > 0
	const validPaymentRequests =
		paymentRequestValidateTemplate?.PaymentRequests?.filter((paymentRequest, index) => {
			return !paymentRequestValidateTemplate.Errors.some((error) => error.ExcelRow === index + 2)
		}) || []

	const onRemoveFile = (fileId) => {
		const remaining = files.filter((file) => file.id !== fileId)
		setFiles(remaining)
		if (remaining.length === 0) {
			setPaymentRequestValidateTemplate(null)
		}
	}

	const onSaveButtonClick = () => {
		if (onImportMassivePaymentRequest) {
			onImportMassivePaymentRequest(files)
		}
	}

	const onValidatePaymentRequestTemplate = (formattedFiles) => {
		dispatch(importMassivePaymentValidateTemplate(formattedFiles))
			.then((data) => {
				setPaymentRequestValidateTemplate(data)
			})
			.catch(() => {})
	}

	return (
		<LateralPanel onClose={onCloseButtonClick}>
			<PanelHeaderIcon
				title={'UPLOAD PAYMENT SUMMARY REPORT'}
				isIconSvgOrPng={true}
				icon={iconDownload}
				onCloseButtonClick={onCloseButtonClick}
			/>
			<DialogContent>
				<Grid item xs={12}>
					<AlertComponent
						title={'Upload report'}
						message={'Upload your payment summary file in .xlsx format. Make sure the file is not damaged.'}
						severityType={'info'}
					/>
					<br />
				</Grid>
				<Grid item xs={12} style={{ marginBottom: '1em' }}>
					<Button
						variant='outlined'
						color='primary'
						component='a'
						href={downloadTemplate}
						download
						fullWidth
						startIcon={<CloudDownloadIcon />}
					>
						Download Template
					</Button>
				</Grid>
				<Grid item xs={12}>
					<DropDownZone
						datacy='drop-zone-documents-operating'
						multiple={false}
						accept={'.xlsx'}
						message={'Click here to add file'}
						onFilesReceived={(newFiles) => {
							const formattedFiles = newFiles.map((file) => ({
								id: file.name + Date.now(),
								attachment: file
							}))
							setFiles(formattedFiles)
							onValidatePaymentRequestTemplate(formattedFiles)
						}}
						disabled={isSaving}
					/>
				</Grid>
				<Grid item xs={12}>
					{files.length > 0 && <FileContent files={files} onRemoveFile={onRemoveFile} />}
				</Grid>

				{paymentRequestValidateTemplate && (
					<Grid item xs={12}>
						{paymentRequestValidateTemplate.Errors && paymentRequestValidateTemplate.TotalErrors > 0 && (
							<Grid item xs={12} style={{ marginTop: '1em', marginBottom: '1em' }}>
								<AlertComponent
									title={`Total Errors: ${paymentRequestValidateTemplate.TotalErrors}`}
									severityType={'info'}
									message=''
								/>
							</Grid>
						)}
						{paymentRequestValidateTemplate.Errors &&
							paymentRequestValidateTemplate.Errors.map((item, index) => (
								<Grid item xs={12} key={`error-${index}`} style={{ marginBottom: '0.5em' }}>
									<AlertComponent message={`${item.Message} in the row ${item.ExcelRow}`} severityType={'error'} />
								</Grid>
							))}

						{validPaymentRequests.length > 0 && (
							<Grid item xs={12} style={{ marginTop: '1em', marginBottom: '1em' }}>
								<AlertComponent title={`Valid Requests: ${validPaymentRequests.length}`} severityType={'info'} message='' />
							</Grid>
						)}
						{validPaymentRequests.map((item, index) => (
							<Grid item xs={12} key={`valid-${index}`} style={{ marginBottom: '0.5em' }}>
								<AlertComponent message={`Folio: ${item.Folio}`} severityType={'success'} />
							</Grid>
						))}
					</Grid>
				)}
				<Grid item xs={12}>
					<br />
					{isSaving && <LinearProgress color='primary' />}
					<br />
					<ButtonConfirm
						title={!isSaving ? 'IMPORT' : 'IMPORTING...'}
						onSavedClick={onSaveButtonClick}
						disabled={canBeSaved() || isSaving || hasErrors || validPaymentRequests.length === 0}
						isSaving={isSaving || canBeSaved() || hasErrors}
					/>
				</Grid>
			</DialogContent>
		</LateralPanel>
	)
}

UploadMassiveImportPanel.propTypes = {
	onCloseButtonClick: PropTypes.func.isRequired,
	onImportMassivePaymentRequest: PropTypes.func.isRequired,
	isSaving: PropTypes.bool
}
UploadMassiveImportPanel.defaultProps = {
	isSaving: false,
	onImportMassivePaymentRequest: () => console.warn('Callback [onImportMassivePaymentRequest] not defined'),
	onCloseButtonClick: () => console.warn('Callback [onCloseButtonClick] not defined')
}

export default UploadMassiveImportPanel
